// dashbaord
import Default from '../components/dashboard/Index'



//nuevos usuarios
import Usuarios from '../components/usuarios/index'
import EditarUsuario from '../components/usuarios/Editar'
import CrearUsuario from '../components/usuarios/Crear'
import Perfil from '../components/usuarios/Profile'

import Roles from '../components/roles/Index'
import CrearRoles from '../components/roles/Crear'
import EditarRoles from '../components/roles/Editar'

import ListaClientes from '../components/clientes/Index'
import CrearClientes from '../components/clientes/Crear'
import EditarClientes from '../components/clientes/Editar'

import ListarTipoContrato from '../components/dashboard/AllDocuments'
import GestorDocumental from '../components/dashboard/Gestor'
import CursosDocente from '../components/contratos/docente'


import ListarModulos from '../components/modulos/Index'
import CrearModulos from '../components/modulos/Crear'
import EditarModulos from '../components/modulos/Editar'

import ListarConfiguracion from '../components/configuracion/Index'
import CrearConfiguracion from '../components/configuracion/Crear'
import EditarConfiguracion from '../components/configuracion/Editar'

import Master from '../components/Master/Index';
import Control from '../components/Control/index';
import Tablero from '../components/Control/tablero';
import Servicio from '../components/Control/servicios';
import ServicioConcluido from '../components/Control/serviciosConcluido';
import Recuperar from '../auth/recuperar';

import Ordenes from '../components/ordenes/Index';
import OrdenesDetalle from '../components/ordenes/index_detalle';
import Detalles from '../components/ordenes/Detalle';
import VistaMapa from '../components/vista-mapa'
import Facturar from '../components/ordenes/FacturarArchivo';
import Liquidar from '../components/ordenes/Liquidar';
import CreaOrden from '../components/ordenes/Crear';
import MaterOrdenes from '../components/ordenes/MaterOrdenes';
import OrdenesPrescritas from '../components/ordenes/OrdenesPrescritas';
import PacientesActivos from '../components/ordenes/PacientesActivos';
import Traslado from '../components/ordenes/Traslado'
import ReportePagos from '../components/ordenes/Reporte'

export const routes = [

  { path: `${process.env.PUBLIC_URL}/pages/orden/:layout`, Component: <Ordenes /> },
  { path: `${process.env.PUBLIC_URL}/pages/orden_detalle/:layout`, Component: <OrdenesDetalle /> },
  { path: `${process.env.PUBLIC_URL}/pages/detalle/:layout`, Component: <Detalles /> },
  { path: `${process.env.PUBLIC_URL}/pages/facturar/:layout`, Component: <Facturar /> },
  { path: `${process.env.PUBLIC_URL}/pages/liquidar/:layout`, Component: <Liquidar /> },
  { path: `${process.env.PUBLIC_URL}/pages/crear_orden/:layout`, Component: <CreaOrden /> },
  { path: `${process.env.PUBLIC_URL}/pages/maestro_ordenes/:layout`, Component: <MaterOrdenes /> },
  { path: `${process.env.PUBLIC_URL}/pages/reporte_adiciones/:layout`, Component: <OrdenesPrescritas /> },
  { path: `${process.env.PUBLIC_URL}/pages/pacientes_activos/:layout`, Component: <PacientesActivos /> },
  { path: `${process.env.PUBLIC_URL}/traslado_ordenes/:layout`, Component: <Traslado /> },

    { path: `${process.env.PUBLIC_URL}/pages/reporte_pagos/:layout`, Component: <ReportePagos /> },

  { path: `${process.env.PUBLIC_URL}/recuperar`, Component: <Recuperar /> },

  { path: `${process.env.PUBLIC_URL}/pages/:idmenu/:layout`, Component: <Master /> },
  { path: `${process.env.PUBLIC_URL}/mis_cursos/:layout`, Component: <ListarTipoContrato /> },
  { path: `${process.env.PUBLIC_URL}/cursos_docente/:layout`, Component: <CursosDocente /> },

  { path: `${process.env.PUBLIC_URL}/pages/usuarios/:layout`, Component: <Usuarios /> },
  { path: `${process.env.PUBLIC_URL}/pages/EditarUsuario/:layout`, Component: <EditarUsuario /> },
  { path: `${process.env.PUBLIC_URL}/pages/AddUsuarios/:layout`, Component: <CrearUsuario /> },
  { path: `${process.env.PUBLIC_URL}/pages/perfil/:layout`, Component: <Perfil /> },

  { path: `${process.env.PUBLIC_URL}/roles/lista/:layout`, Component: <Roles /> },
  { path: `${process.env.PUBLIC_URL}/roles/crear/:layout`, Component: <CrearRoles /> },
  { path: `${process.env.PUBLIC_URL}/roles/editar/:layout`, Component: <EditarRoles /> },

  { path: `${process.env.PUBLIC_URL}/clientes/lista/:layout`, Component: <ListaClientes /> },
  { path: `${process.env.PUBLIC_URL}/clientes/crear/:layout`, Component: <CrearClientes /> },
  { path: `${process.env.PUBLIC_URL}/clientes/editar/:layout`, Component: <EditarClientes /> },


  { path: `${process.env.PUBLIC_URL}/mapa_documentos/:layout`, Component: <ListarTipoContrato /> },
  { path: `${process.env.PUBLIC_URL}/gestor/:layout`, Component: <GestorDocumental /> },

  { path: `${process.env.PUBLIC_URL}/modulos/lista/:layout`, Component: <ListarModulos /> },
  { path: `${process.env.PUBLIC_URL}/modulos/crear/:layout`, Component: <CrearModulos /> },
  { path: `${process.env.PUBLIC_URL}/modulos/editar/:layout`, Component: <EditarModulos /> },

  { path: `${process.env.PUBLIC_URL}/configuracion/lista/:layout`, Component: <ListarConfiguracion /> },
  { path: `${process.env.PUBLIC_URL}/configuracion/mapa/:layout`, Component: <VistaMapa /> },
  { path: `${process.env.PUBLIC_URL}/configuracion/crear/:layout`, Component: <CrearConfiguracion /> },
  { path: `${process.env.PUBLIC_URL}/configuracion/editar/:layout`, Component: <EditarConfiguracion /> },



  //------------------nuevos modulos------------------------
  { path: `${process.env.PUBLIC_URL}/dashboard/default/:layout/`, Component: <Default /> },
  { path: `${process.env.PUBLIC_URL}/control/:layout/`, Component: <Control /> },
  { path: `${process.env.PUBLIC_URL}/tablero/:layout/`, Component: <Tablero /> },
  { path: `${process.env.PUBLIC_URL}/servicios/:layout/`, Component: <Servicio /> },
  { path: `${process.env.PUBLIC_URL}/servicios_concluidos/:layout/`, Component: <ServicioConcluido /> },
  { path: `${process.env.PUBLIC_URL}/alertas/:alerta/:layout`, Component: <Default /> },


]